import { ChangeDetectionStrategy, Component, computed, effect, inject, signal } from '@angular/core';
import { AuthService, Menubar, MenuItem } from "@bayclubs/horizon";
import { PrivilegesApiService } from '../../../core/services/privileges-api.service';

@Component({
	selector: 'app-menubar',
	imports: [
		Menubar
	],
	templateUrl: './menubar.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenubarComponent {

	private readonly msalAuth = inject(AuthService);
	private readonly privilegesApi = inject(PrivilegesApiService);

	private readonly isAuthorized = computed(() => this.msalAuth.isAuthenticated());
	private readonly canImportProducts = signal(false);
	private readonly canViewProductMatrix = signal(false);

	constructor() {
		effect(() => {
			if (this.msalAuth.isAuthenticated()) {
				this.loadPrivileges();
			}
		});
	}

	private loadPrivileges(): void {
		this.privilegesApi.get().subscribe({
			next: (privileges) => {
				this.canImportProducts.set(privileges.canImportProducts);
				this.canViewProductMatrix.set(privileges.canViewProductMatrix);
			}
		});
	}

	items = computed<MenuItem[]>(() => {
		const items = [];

		if (this.isAuthorized()) {
			items.push({
				label: 'Purchases',
				routerLink: '/purchases'
			});

			items.push({
				label: 'Live Sales',
				routerLink: '/wallboard'
			});

			// Sales Dashboard is reachable at /sales-dashboard; menu entry hidden until rollout
			// items.push({
			// 	label: 'Sales Dashboard',
			// 	routerLink: '/sales-dashboard'
			// });

			if (this.canImportProducts()) {
				items.push({
					label: 'Product Import',
					routerLink: '/product-import'
				});
			}

			if (this.canViewProductMatrix()) {
				items.push({
					label: 'Product Matrix',
					routerLink: '/product-matrix'
				});
			}
		}

		return items;
	});

	userName = computed(() => firstName(this.msalAuth.userName()));

	handleLogout(): void {
		this.msalAuth.logoutRedirect();
	}
}

function firstName(name: string | null | undefined): string | null {
	if (!name) return null;
	const parts = name.trim().split(/\s+/).filter(Boolean);
	return parts.length > 0 ? parts[0] : null;
}
